import React, { useState, useEffect } from 'react';
import '../../styles/onboardingFlow/mobileLogoCard/mobileLogoCard.scss';
import adupLogoSet from '../../assets/onboarding/common/adup-logo-set.png';
import MobileLogoSlide1 from './MobileLogoSlide1';
import MobileLogoSlide2 from './MobileLogoSlide2';
import MobileLogoSlide3 from './MobileLogoSlide3';
import MobileLogoSlide4 from './MobileLogoSlide4';

const SLIDES = [
  MobileLogoSlide1,
  MobileLogoSlide2,
  MobileLogoSlide3,
  MobileLogoSlide4,
];

const SLIDE_INTERVAL_MS = 4500;

const MobileLogoCard: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % SLIDES.length);
    }, SLIDE_INTERVAL_MS);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className='mobileLogoCard'>
      <div className='mobileLogoCard__slideshow'>
        {SLIDES.map((SlideComponent, index) => (
          <div
            key={index}
            className={`mobileLogoCard__slide ${
              index === activeIndex ? 'mobileLogoCard__slide--active' : ''
            }`}
            aria-hidden={index !== activeIndex}
          >
            <SlideComponent />
          </div>
        ))}
      </div>
      <div className='mobileLogoCard__logo-strip'>
        <img
          src={adupLogoSet}
          alt='TARA AdUp'
          className='mobileLogoCard__logo'
        />
      </div>
    </div>
  );
};

export default MobileLogoCard;
